import React from 'react';

import { CustomNextImage as Image } from '@crehana/next';

import { Container, Row, Col } from '@crehana/ui/dist/GridV2';

import { useTranslation } from '@crehana/i18n';

import { AboutSectionProps } from './types';

const AboutSection: React.FC<React.PropsWithChildren<AboutSectionProps>> = ({
  title,
  description,
  professor,
}) => {
  const { t } = useTranslation();

  return (
    <section className="bg-gray-lighter py-64 md:py-112 md:pb-80">
      <Container>
        <Row>
          <Col offset={{ md: 1 }} md={10}>
            <Row>
              <Col xs={12} sm={5} md={5} className="flex items-center">
                <div className="flex flex-col justify-center items-center mb-24 sm:mb-0 w-full sm:w-auto">
                  <div className="h-212 w-280 lg:h-280 lg:w-360 mb-24 relative">
                    <Image
                      alt={t(title)}
                      src={professor.profile}
                      layout="fill"
                      objectFit="cover"
                      objectPosition="center"
                    />
                  </div>
                  <p className="font-subtitle4">{professor.name}</p>
                  <p className="font-body4 text-gray-main-dark-mode">
                    {t(professor.occupation)}
                  </p>
                </div>
              </Col>
              <Col
                xs={12}
                sm={7}
                md={7}
                className="flex flex-col justify-center"
              >
                <div>
                  <h2 className="font-h3 mb-24">{t(title)}</h2>
                  <p className="font-body3">{t(description)}</p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;
